/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu88HPE%7Bgap%3Avar(--ds-space-150%2C9pt)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbgBM8%7Bdisplay%3Agrid%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2iEGP2zmBj%7Bgrid-template-columns%3Arepeat(auto-fill%2Cminmax(22pc%2C1fr))%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._46hvQmPgdg%7Bpadding-block-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0xmtkoPgdg%7Bpadding-block-end%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5EPgdg%7Bpadding-inline-start%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCPPgdg%7Bpadding-inline-end%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A64rem)%7B._1FQBgZ5zaO%7Bgap%3Avar(--ds-space-200%2C1pc)%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbcK7c%7Bdisplay%3Acontents%7D");
import React, { type ReactNode } from 'react';
import LegacyBox from '@atlaskit/primitives/box';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Grid } from '@atlaskit/primitives/compiled/grid';
import { Grid as LegacyGrid } from '@atlaskit/primitives/grid';
import { media } from '@atlaskit/primitives/responsive/media';
import Stack from '@atlaskit/primitives/stack';
// eslint-disable-next-line @townsquare/rules/no-xcss
import { xcss } from '@atlaskit/primitives/xcss';
import { useRecommendedAgents } from '@atlassian/conversation-assistant-agent/controllers/agents';
import { RovoEntitlementSetter } from '@atlassian/conversation-assistant-entitlement/controllers/rovo-entitlement';
import type { Agent } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import { FormattedMessage, useIntl } from 'react-intl';
import { useAnalytics } from '@townsquare/analytics';
import { useRovoWorkspace } from '@townsquare/collab-context';
import { useOnMount } from '@townsquare/hooks';
import { teamsAppAgentsDirectoryRoute } from '@townsquare/routes/teams-app-agents-directory-view';
import { useRovoEntitlement } from '@townsquare/rovo/entitlement';
import { useAssistanceServiceParams } from '@townsquare/rovo/hooks';
import { fg } from '@townsquare/stat-sig/gate';
import { Heading } from '../Heading';
import { Agent as AgentCard } from './Card';
import { AgentSkeleton } from './Card/Skeleton';
const MAX_AGENTS = 3;
const gridStyles = xcss({
  display: 'grid',
  gap: 'space.150',
  // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
  [media.above.md]: {
    gap: 'space.200'
  },
  gridTemplateColumns: `repeat(auto-fill, minmax(352px, 1fr))`,
  padding: 'space.0'
});
const listItemStyles = xcss({
  display: 'contents'
});
const styles = {
  grid: "_2mHwu88HPE _3iDTPbgBM8 _2iEGP2zmBj _46hvQmPgdg _0xmtkoPgdg _0LQT5EPgdg _03SyCPPgdg _1FQBgZ5zaO",
  listItem: "_3iDTPbcK7c"
};
function ConfigureRovoWrapper(): React.JSX.Element | null {
  const {
    data,
    loading
  } = useRovoEntitlement();
  if (loading) {
    return <AgentsRowSkeleton />;
  }
  if (data?.isRovoEnabled && data?.isRovoLLMEnabled) {
    return <>
				<RovoEntitlementSetter isRovoEnabled={true} />
				<AgentsRowWithDataFetching />
			</>;
  }
  return null;
}
function BrowseAgentsView({
  children,
  onMount,
  useListMarkup
}: {
  children: ReactNode;
  onMount?: () => void;
  useListMarkup?: boolean;
}) {
  const intl = useIntl();
  useOnMount(() => {
    if (onMount) onMount();
  });
  return <Stack space="space.100" testId="browse-agents-section">
			<Heading browseMore={{
      text: intl.formatMessage({
        id: 'townsquare.web.staff-directory-view.browse-all-agents',
        defaultMessage: 'Browse all agents',
        description: 'Link text in the recommended agents section heading that navigates to the full agents directory.'
      }),
      linkProps: {
        to: teamsAppAgentsDirectoryRoute,
        query: {
          screen: 'SEARCH_AGENTS'
        }
      }
    }} screenType="BROWSE_AGENTS">
				<FormattedMessage id="townsquare.staff-directory.browse-agents-section.title" description="Title for the recommended agents section" defaultMessage="Recommended agents" />
			</Heading>
			{fg('townsquare-compiled-xcss-to-cssmap-final') ? <Grid xcss={styles.grid} as={useListMarkup ? 'ul' : undefined}>
					{children}
				</Grid> : <LegacyGrid xcss={gridStyles} as={useListMarkup ? 'ul' : undefined}>
					{children}
				</LegacyGrid>}
		</Stack>;
}
export function AgentsRowSkeleton(): React.JSX.Element {
  return <BrowseAgentsView>
			{Array.from({
      length: MAX_AGENTS
    }).map((_, index) => <AgentSkeleton key={index} />)}
		</BrowseAgentsView>;
}
function AgentsRowWithDataFetching() {
  const rovoWorkspaceCloudId = useRovoWorkspace();
  const cloudId = rovoWorkspaceCloudId ?? '';
  const assistanceServiceParams = useAssistanceServiceParams({
    experienceId: 'teams-agents-for-you',
    touchpointSource: 'teams-agents-for-you'
  });
  const {
    isFetching,
    recommendedAgents
  } = useRecommendedAgents({
    assistanceServiceParams
  });
  if (isFetching) {
    return <AgentsRowSkeleton />;
  }
  if (!recommendedAgents || recommendedAgents.length < MAX_AGENTS) {
    return null;
  }
  return <AgentsRowUI agents={recommendedAgents.slice(0, MAX_AGENTS)} cloudId={cloudId} />;
}
export function AgentsRowUI({
  agents,
  cloudId
}: {
  agents: Agent[];
  cloudId: string;
}): React.JSX.Element {
  const analytics = useAnalytics();
  return <BrowseAgentsView onMount={() => void analytics.screen('recommendedAgentsSection')} useListMarkup>
			{agents.map(agent => fg('townsquare-compiled-xcss-to-cssmap-final') ? <Box as="li" key={agent.id} xcss={styles.listItem}>
						<AgentCard {...agent} siteId={cloudId} />
					</Box> : <LegacyBox as="li" key={agent.id} xcss={listItemStyles}>
						<AgentCard {...agent} siteId={cloudId} />
					</LegacyBox>)}
		</BrowseAgentsView>;
}

// Single re-export only, not a barrel.
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { ConfigureRovoWrapper as AgentsRow };